"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCsrfHeader;

/**
 * The underlying services set csrf token as integers, and expect integers; not strings
 * So this function reads the string value from the meta and converts it to integer
 */
function getCsrfHeader() {
  var csrf = document.querySelector('meta[name="csrf-token"]') && document.querySelector('meta[name="csrf-token"]').content;
  if (csrf) return {
    'X-Csrf-Token': csrf
  };
  return {};
}